function injectStyle (ssrContext) {
  require("!!vue-style-loader!css-loader!../../vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-9ca4d75c\",\"scoped\":false,\"hasInlineConfig\":false}!sass-loader!../../vue-loader/lib/selector?type=styles&index=0!./Notification.vue")
}
var Component = require("!../../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../vue-loader/lib/selector?type=script&index=0!./Notification.vue"),
  /* template */
  require("!!../../vue-loader/lib/template-compiler/index?{\"id\":\"data-v-9ca4d75c\",\"hasScoped\":false}!../../vue-loader/lib/selector?type=template&index=0!./Notification.vue"),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/vue-bulma-notification/src/Notification.vue
// module id = 53
// module chunks = 4